<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Georgian Bars';
                }
            },
            component_id: {
                default(){
                    return 'georgian_bars';
                }
            },
            slab: {
                required: true,
            },
            maintitle: {
                default() {
                    return 'Select Georgian Bars';
                }
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/georgian-bars/';
            },
            passed_filter(){
                return this.variable_ready(this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/georgian-bars?slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.slab;
            },
            panel_required(){
                return this.filtered_option_list.length > 0
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
